import React from "react";
import './detailpage.scss';
import Dropdown from 'react-bootstrap/Dropdown';
import AssistBar from '../components/assistbar';
// import ToolBar from '../components/toolbar';

var des_text = []

class DetailPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            listContent:{},
            category:null,
            item:"item1",
            imgNum:1,
            maxImgNum: null,
            itemSelected:{},
            optionDisplay:{},
            productOptions:{},
            unitPrice:null,
        }
      }

componentDidMount(){
   var maxImgNum = this.state.maxImgNum 
   maxImgNum = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["img"]
   var default_optionsDisplay = {}
   var default_productOptions = {}
   var unitprice = 0
   for(var ll in this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"]){
    default_optionsDisplay[ll] = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"][ll]["1"]
    default_productOptions[ll] = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"][ll][1]
   }
   if(typeof(this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"])==="object"){
    unitprice = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"]["medium"]
    if(unitprice===undefined){
        unitprice = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"]["100CM"] //suit
    }
   } else {
    unitprice = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"]
   }

   this.setState({maxImgNum:maxImgNum,optionDisplay:default_optionsDisplay,productOptions:default_productOptions,unitPrice:unitprice})
   
}

  render(){

        des_text = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["description"].split('\n\r')
       

    return (
      <div className="detailpage-main">

        <AssistBar {...this.props} setval={this.props.setval} />

        <div className="detailpage-half">
            

            <div className="detailpage-img-wrapper">
                <div className="detailpage-img-nav" onClick={(e)=>{
                    var img_num = this.state.imgNum
                    
                    if(img_num===1){
                        img_num = this.state.maxImgNum
                    }
                    else{
                        img_num -= 1
                    }
                    this.setState({imgNum:img_num})
                }}>
                    {"<"}
                </div>
                <div className="detailpage-img">
                    {/* <div className="detailpage-zoom" >{"Click to Zoom"}</div> */}
                    <img className={(this.props.chosenProduct["cat"]==="book")?"detailpage-booksize":""} src={"/assets/"+this.props.chosenProduct["cat"]+"-"+this.props.chosenProduct["item"]+"-"+this.state.imgNum+".PNG"} width="100%" alt={"IMG"} />
                </div>
                <div className="detailpage-img-nav" onClick={(e)=>{
                    var img_num = this.state.imgNum
                    
                    if(img_num===this.state.maxImgNum){
                        img_num = 1
                    }
                    else{
                        img_num += 1
                    }
                    this.setState({imgNum:img_num})
                }}>
                    {">"}
                </div>
            </div>

            <div className="detailpage-bar">
                <div className={["detailpage-textblock","title"].join(" ")}>
                    <u>Description</u>
                </div>
                <div className="detailpage-textblock">
                    { 
                    // des_text
                        des_text.map((i,idx)=>{
                            return(
                                <div>{des_text[idx]}</div>
                            )
                        })
                    }
                    {/* {this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["description"]}     */}
                </div>
                {
                    (this.props.chosenProduct["cat"]==="suit") && 

                    <div style={{marginTop:"40px"}}>
                    <div style={{fontSize:"0.7rem"}}><sup>*</sup>Actual size may vary slightly according to cutting</div>
                    <table className="tg" style={{marginTop:"20px"}}><thead>
                    <tr>
                        <th className="tg-0lax"></th>
                        <th className="tg-0lax">Jacket Length</th>
                        <th className="tg-0lax">Shoulder Width</th>
                        <th className="tg-0lax">Chest</th>
                        <th className="tg-0lax">Sleeve</th>
                        <th className="tg-0lax">Trousers Length</th>
                        <th className="tg-0lax">Waist</th>
                        <th className="tg-0lax">Hip</th>
                    </tr></thead>
                    <tbody>
                    <tr>
                        <td className="tg-0lax">90CM</td>
                        <td className="tg-0lax">36cm</td>
                        <td className="tg-0lax">25.4cm</td>
                        <td className="tg-0lax">63cm</td>
                        <td className="tg-0lax">30.5cm</td>
                        <td className="tg-0lax">47cm</td>
                        <td className="tg-0lax">46cm</td>
                        <td className="tg-0lax">63cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">100CM</td>
                        <td className="tg-0lax">39cm</td>
                        <td className="tg-0lax">25.2cm</td>
                        <td className="tg-0lax">66cm</td>
                        <td className="tg-0lax">32cm</td>
                        <td className="tg-0lax">52cm</td>
                        <td className="tg-0lax">48cm</td>
                        <td className="tg-0lax">66cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">110CM</td>
                        <td className="tg-0lax">42cm</td>
                        <td className="tg-0lax">27.7cm</td>
                        <td className="tg-0lax">70cm</td>
                        <td className="tg-0lax">35.5cm</td>
                        <td className="tg-0lax">57cm</td>
                        <td className="tg-0lax">50cm</td>
                        <td className="tg-0lax">70cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">120CM</td>
                        <td className="tg-0lax">45cm</td>
                        <td className="tg-0lax">29.2cm</td>
                        <td className="tg-0lax">74cm</td>
                        <td className="tg-0lax">39cm</td>
                        <td className="tg-0lax">62cm</td>
                        <td className="tg-0lax">53cm</td>
                        <td className="tg-0lax">74cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">130CM</td>
                        <td className="tg-0lax">48cm</td>
                        <td className="tg-0lax">30.7cm</td>
                        <td className="tg-0lax">78cm</td>
                        <td className="tg-0lax">42.5cm</td>
                        <td className="tg-0lax">68cm</td>
                        <td className="tg-0lax">56cm</td>
                        <td className="tg-0lax">78cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">140CM</td>
                        <td className="tg-0lax">51cm</td>
                        <td className="tg-0lax">32.2cm</td>
                        <td className="tg-0lax">82cm</td>
                        <td className="tg-0lax">46cm</td>
                        <td className="tg-0lax">75cm</td>
                        <td className="tg-0lax">59cm</td>
                        <td className="tg-0lax">82cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">150CM</td>
                        <td className="tg-0lax">54cm</td>
                        <td className="tg-0lax">33.7cm</td>
                        <td className="tg-0lax">86cm</td>
                        <td className="tg-0lax">49.5cm</td>
                        <td className="tg-0lax">82cm</td>
                        <td className="tg-0lax">62cm</td>
                        <td className="tg-0lax">86cm</td>
                    </tr>
                    <tr>
                        <td className="tg-0lax">160CM</td>
                        <td className="tg-0lax">57cm</td>
                        <td className="tg-0lax">35.2cm</td>
                        <td className="tg-0lax">90cm</td>
                        <td className="tg-0lax">52.5cm</td>
                        <td className="tg-0lax">89cm</td>
                        <td className="tg-0lax">65cm</td>
                        <td className="tg-0lax">90cm</td>
                    </tr>
                    </tbody></table>
                    </div>
                }
            </div>
        </div>


                    {/* right panel */}
        <div className="detailpage-half">

            
            <div className="detailpage-option-wrapper">

                 <div className="detailpage-dropdown-wrapper" >
                
                 <div className={["detailpage-bar","title"].join(" ")} style={{marginTop:"10%"}}>
                    <u>{this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["name"]}</u>
                </div>

                
                    <div className="detailpage-dropdown-row">
                        <div className={"title"} style={{flexGrow:"1",fontSize:"2rem"}}>{"Price (USD)"}</div>
                        <div className={"title"} style={{flexGrow:"2",fontSize:"2rem",fontWeight:"600"}}>{this.state.unitPrice}</div>
                    </div>

                    {
                        (this.props.chosenProduct["cat"] === "book") &&
                        <div className="detailpage-book-section-wrapper">
                             <div className="detailpage-book-section">
                                <div>{"For ages :  "}</div>
                                <div>{this.props.productList["book"][this.props.chosenProduct["item"]]["age"]}</div>
                            </div>
                            <div className="detailpage-book-section">
                                <div>{"Pages :  "}</div>
                                <div>{this.props.productList["book"][this.props.chosenProduct["item"]]["length"]}</div>
                            </div>
                            <div className="detailpage-book-section">
                                <div>{"Format :  "}</div>
                                <div>{this.props.productList["book"][this.props.chosenProduct["item"]]["format"]}</div>
                            </div>
                            <div className="detailpage-book-section">
                                <div>{"Publisher :  "}</div>
                                <div>{this.props.productList["book"][this.props.chosenProduct["item"]]["publisher"]}</div>
                            </div>
                            <div className="detailpage-book-section">
                                <div>{"Published year :  "}</div>
                                <div>{this.props.productList["book"][this.props.chosenProduct["item"]]["publishyear"]}</div>
                            </div>
                            
                           
                            <div className="detailpage-book-section">
                                <div>{"ISBN :  "}</div>
                                <div>{this.props.productList["book"][this.props.chosenProduct["item"]]["ISBN"]}</div>
                            </div>
                        </div>
                        
                    }


                </div>

                <div style={{minWidth:"100%",marginTop:"10%",marginBottom:"10px"}}>
                    <div className={["detailpage-bar","button"].join(" ")} onClick={(e)=>{
                        var cart = this.props.shoppingCart
                        var op_str = ""
                        for (var tt in this.state.productOptions){
                            op_str = op_str + this.state.productOptions[tt]
                        }
                        const key = this.props.chosenProduct["cat"]+"-"+this.props.chosenProduct["item"]+"-"+op_str
                        if (key in cart){
                            // alert("inin")
                            cart[key]["quantity"] = cart[key]["quantity"] + 1
                            // alert(JSON.stringify(cart))
                            this.props.setval({shoppingCart:cart})
                        } 
                        else {
                            // alert("notin")
                            var j_key = this.props.chosenProduct["cat"]+"-"+this.props.chosenProduct["item"]+"-"+op_str
                            // alert(j_key)
                            var json = {}
                            var u_price = 0
                            if(typeof this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"] === "object"){
                                u_price =  this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"][this.state.productOptions["size"]]
                            } else {
                                u_price = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"]
                            }
                            json[j_key] = {
                                "name":this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["name"],
                                "cat":this.props.chosenProduct["cat"],
                                "item":this.props.chosenProduct["item"],
                                "options":this.state.productOptions,
                                "quantity":1,
                                "unit_price":u_price,
                            } 
                            Object.assign(cart,json);
                            // alert(JSON.stringify(cart))
                            this.props.setval({shoppingCart:cart})
                        }

                        alert("Item added to cart")
                        
                    }}>
                        {"Add to Cart"}
                    </div>
                </div>


                {/* <div className={["detailpage-bar","title"].join(" ")}>
                        <u>{"Price"}</u>
                </div> */}

                
                {  (Object.keys(this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"] || {}).length >0) &&
                    <div className={["detailpage-bar","title"].join(" ")}>
                        <u>{"Product Options"}</u>
                    </div>
                }

                <div className="detailpage-dropdown-wrapper" >
                    {  (Object.keys(this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"] || {}).length >0) &&
                        Object.keys(this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"]).map((i)=>{
                            return(
                                <div key={i} className="detailpage-dropdown-row">
                                    <div style={{flexGrow:"1"}}>{i}</div>
                                    <div style={{flexGrow:"2"}}>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                {this.state.optionDisplay[i]}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {
                                                    Object.keys(this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"][i]).map((j)=>{
                                                        return(
                                                            <Dropdown.Item  onClick={(e)=>{
                                                                var display = this.state.optionDisplay
                                                                var options = this.state.productOptions
                                                                var unitprice = this.state.unitPrice
                                                                options[i] = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"][i][j]
                                                                display[i] = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"][i][j]
                                                                if(i === "size"){
                                                                    unitprice = this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["price"][display[i]]
                                                                    // alert(unitprice)
                                                                }
                                                                this.setState({optionDisplay:display,productOptions:options,unitPrice:unitprice})

                                                            }}>{this.props.productList[this.props.chosenProduct["cat"]][this.props.chosenProduct["item"]]["options"][i][j]}</Dropdown.Item>
                                                        )
                                                    })
                                                }
                                            
                                                {/* <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
                                            </Dropdown.Menu>
                                            </Dropdown>
                                    </div>
                                </div>
                            )
                        })
                    }
                

                </div>


            </div>

         
        </div>

      </div>
    );


  }
}

export default DetailPage;
